module.exports = __webpack_public_path__ + "static/media/layer7.37fb1fa5.svg";